import React from 'react';

import { SmartCreateSpaceLoader } from '@confluence/smart-create-space';
import { fg } from '@confluence/feature-gating';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';

export const SpaceSmartCreateRoute = () => {
	if (!fg('aifc_space_creation_enabled')) {
		return <Redirection href={HOME.toUrl()} />;
	}

	return <SmartCreateSpaceLoader />;
};

SpaceSmartCreateRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'spaceSmartCreateScreen',
		},
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
